import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FAQSection from '../components/FAQSection';
import Meta from '../components/Meta';

// Buy-intent questions first (highest AEO value), then the informational ones.
const FAQ_ITEMS = [
  { q: 'faqBuyQ1', a: 'faqBuyA1' }, // where to buy
  { q: 'faqBuyQ2', a: 'faqBuyA2' }, // shipping & delivery
  { q: 'faqBuyQ3', a: 'faqBuyA3' }, // payment methods
  { q: 'faqBuyQ4', a: 'faqBuyA4' }, // authenticity & freshness
  { q: 'faqBuyQ5', a: 'faqBuyA5' }, // gift boxes
  { q: 'faqQuestion1', a: 'faqAnswer1' },
  { q: 'faqQuestion2', a: 'faqAnswer2' },
  { q: 'faqQuestion3', a: 'faqAnswer3' },
  { q: 'faqQuestion4', a: 'faqAnswer4' },
];

function FaqScreen() {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map((it) => ({
      '@type': 'Question',
      name: t(it.q),
      acceptedAnswer: { '@type': 'Answer', text: t(it.a) },
    })),
  };

  return (
    <Container>
      <Meta
        title={isAr ? 'الأسئلة الشائعة - شراء التمور السعودية أونلاين | تمرات' : 'FAQ - Buying Saudi Dates Online | Tamrat Dates'}
        description={
          isAr
            ? 'إجابات عن أكثر الأسئلة شيوعًا حول شراء التمور السعودية أونلاين: أين تشتري، تكلفة الشحن والتوصيل، طرق الدفع، الأصناف والفوائد.'
            : 'Answers to the most common questions about buying Saudi dates online: where to buy, shipping & delivery, payment methods, varieties and benefits.'
        }
        url={'https://tamratdates.com/frequently-asked-questions'}
        schema={faqSchema}
      />
      <h1 className="title">
        {t('faqPage')}
        <br />
        <hr className="mt-2" style={{ opacity: 1, color: '#DAB155', width: '100px', margin: 'auto', height: '8px', borderWidth: '5px' }} />
        <br />
      </h1>
      <FAQSection items={FAQ_ITEMS} />
    </Container>
  );
}

export default FaqScreen;
